export enum StatusEnum {
  online = 1,
  out = 2,
  stock = 3,
}

export enum TypeEnum {
  real = 1,
  virtual = 2,
}

export enum PostageTypeEnum {
  free,
  cost,
}

export const STATUS_LIST: SelectOption[] = [
  { label: '上架中', value: StatusEnum.online },
  { label: '已售罄', value: StatusEnum.out },
  { label: '仓库中', value: StatusEnum.stock },
];

export const TYPE_LIST: SelectOption[] = [
  { label: '实物商品', value: TypeEnum.real },
  { label: '虚拟商品', value: TypeEnum.virtual },
];

export const TYPE_MAP = TYPE_LIST.reduce((map: any, ele) => {
  map[ele.value] = ele.label;
  return map;
}, {});

export const WARE_TYPE_LIST = [
  { value: 0, label: '全部' },
  { value: 1, label: '实物' },
  { value: 2, label: '虚拟', children: [ { value: 0, label: '无' }, { value: 1, label: '兑换码' } ] },
];

export const STOCK_PATTERN = [
  { label: '一级拿货，二级自由消耗', value: 1, description: [ '一级设置固定库存，同时扣减商品库存；', '二级是自由消耗所属一级库存，销完即止。' ] },
  { label: '一级、二级拿货', value: 2, description: [ '一级设置固定库存，同时扣减商品库存；', '二级是从所属一级拿货，同时扣减一级库存，二者各自销完即止。' ] },
  { label: '一级、二级自由消耗', value: 3, description: [ '一、二级均自由消耗商品库存。' ] },
];
